
export default {

  ADD_EMAIL(state, senderEmailData) {
    state.senderEmailData = senderEmailData
  },
  DELETE_EMAIL(state, id) {
    const itemIndex = state.senderEmailData.items.findIndex(value => value.id === id);
    if (itemIndex !== -1) {
      state.senderEmailData.items.splice(itemIndex, 1);
    }
  },
  UPDATE_EMAIL(state, updatedData) {
    const itemIndex = state.senderEmailData.items.findIndex(value => value.id === updatedData.id);
    if (itemIndex !== -1) {
      Object.assign(state.senderEmailData.items[itemIndex], updatedData);
    }
  },
  SET_EMAILS_PAGINATED(state, senderEmailData) {
    state.senderEmailData = senderEmailData;
  },
  UPDATE_SENDER_STATUS(state, data) {
    if (!state.senderEmailData.items) return;

    const itemIndex = state.senderEmailData.items.findIndex(value => value.id === data.id);

    if (itemIndex !== -1) {
      const updated  = { ...state.senderEmailData.items[itemIndex] };
      updated.status = data.value;
 
      Object.assign(state.senderEmailData.items[itemIndex], updated);
    }
  }
}
